import { queryApi } from '../../../api'
import { ENDPOINT } from '../../../constants'
import { IArkivinfoSkjermedeOrdMutateVars } from '../types'

export const arkivinfoApi = {
  getArkivinfo: async (kvitteringId: string) =>
    queryApi.get<ITilsynskvitteringRemote.ArkivInfoRes>(
      `${ENDPOINT.TILSYNSKVITTERING}/tilsynskvitteringer/${kvitteringId}/arkivinfo`
    ),
  updateSkjermedeOrd: async ({
    kvitteringId,
    skjermedeOrd,
  }: IArkivinfoSkjermedeOrdMutateVars) =>
    queryApi.put(
      `${ENDPOINT.TILSYNSKVITTERING}/tilsynskvitteringer/${kvitteringId}/arkivinfo`,
      { skjermedeOrd }
    ),
}
